<template>
    <b-table
        id="indices"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum índice encontrado.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Descrição <i class="filter" :class="!isEmpty(filtro.descricao) || filtro.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Descrição', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            {{ item.descricao }}
        </template>
        <template v-slot:head(2)="{ item }">
            Tipo <i class="filter" :class="!isEmpty(filtro.tipos) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo', 'checkbox', listaTipoIndice, null, $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            {{ item.tipoIndice }}
        </template>
        <template v-slot:head(3)="{ item }">
            Data de Última Atualização <i class="filter" :class="!isEmpty(filtro.atualizacao) || filtro.filtrarAtualizacao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Última Atualização', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            <p class="text-center">
                {{ item.dataAtualizacao }}
            </p>
        </template>
        <template v-slot:head(4)="{ item }">
            Usuário da Última Alteração <i class="filter" :class="!isEmpty(filtro.usuario) || filtro.filtrarUsuario == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário da Última Alteração', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            {{ item.usuarioAlteracao }}
        </template>
        <template v-slot:head(5)="{ item }">
            Cumulatividade do Índice <i class="filter" :class="!isEmpty(filtro.cumulatividade) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Cumulatividade do Índice', 'radio', 'Cumulavel,Inacumulavel', null, $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            {{ item.inacumulavel }}
        </template>
        <template v-slot:head(6)="{ item }">
            Situação <i class="filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'radio', 'Ativo,Inativo', null, $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.situacao }}
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';

export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'listaTipoIndice', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.selecteds.push(item);
            } else {
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
